import { computed, nextTick, ref, type Ref } from 'vue';
import type { CompiledForm } from '@record-fill';
import { pulseOnPaper } from './fill-logs-dom';
import { buildFillLogsText, type FillLogsPaperTarget } from './fill-logs-text';
import { UNKNOWN_AUTHOR, type FillLogsResponseView } from './fill-logs-timeline';

export type FillLogsView = 'form' | 'changes';

// The view and the "all fields" toggle outlive the response picked next: comparing the same view
// across responses is the point of the screen.
export function useFillLogsReading(
  compiled: Ref<CompiledForm | null>,
  current: Ref<FillLogsResponseView | null>,
  timeline: Ref<FillLogsResponseView[]>,
  deviceTitles: Ref<boolean>,
) {
  const view = ref<FillLogsView>('form');
  const showAll = ref(false);
  const paperRef = ref<HTMLElement | null>(null);

  const authors = computed(() => new Map(timeline.value.map((response) => [response.number, response.authorName])));
  const text = computed(() => {
    if (!compiled.value || !current.value) return null;
    return buildFillLogsText(compiled.value, current.value.marks, (number) => authors.value.get(number) ?? UNKNOWN_AUTHOR, {
      deviceTitles: deviceTitles.value,
    });
  });

  async function showOnPaper(item: FillLogsPaperTarget): Promise<void> {
    view.value = 'form';
    await nextTick();
    if (paperRef.value) pulseOnPaper(paperRef.value, item);
  }

  return { view, showAll, paperRef, text, showOnPaper };
}
